import type { StatsSnapshot } from './gameplay-snapshot';
import { unitStats as stats } from './index';

export const updateOutpostStats = (state: StatsSnapshot) => {
  const outpost = state.generators.outpost;

  const generatedElves = outpost.owned * outpost.baseGeneration;

  stats.outpost = {
    unitsGeneration: generatedElves,
  };
};
